import { pimAppPath } from '../../../util/paths';

// APP paths
export const rootPath = `${pimAppPath}`;

export default rootPath;
